import { getRoles } from "../api/services/AuthService";

export default function PermissionGate({
  roles = [],
  children,
  fallback = null,
}) {
  const userRoles = getRoles();

  const allowed =
    roles.length === 0 || roles.some((r) => userRoles.includes(r));

  return allowed ? children : fallback;
}